module.exports = __webpack_public_path__ + "static/media/slowBackground.a832399a.mp3";